import { css, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';
import { WhatsAppPreviewStyleProps } from './WhatsAppPreview.types';

const styles = {
  root: ({ props }) => css`
    position: relative;
    width: ${props.imageWidth}px;
    height: ${props.height}px;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  `,
  imageContainer: () => css`
    position: relative;
    width: 100%;
    height: 100%;
  `,
  backgroundImage: () => css`
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: auto;
    object-fit: contain;
    object-position: left center;
  `,
  itemsContainer: ({ props }) => {
    const baseHeight = 600;
    const scale = props.height / baseHeight;

    const containerTop = 80 * scale;
    const containerLeft = 10 * scale;
    const containerMaxWidth = Math.min(75 * scale, props.imageWidth * 0.75);

    return css`
      position: absolute;
      top: ${containerTop}px;
      left: ${containerLeft}px;
      max-width: ${containerMaxWidth}px;
      display: flex;
      flex-direction: column;
      gap: ${12 * scale}px;
      z-index: 1;
    `;
  },
  messageBubble: ({ theme, props }) => {
    const baseHeight = 600;
    const scale = props.height / baseHeight;

    const padding = `${12 * scale}px ${16 * scale}px`;
    const borderRadius = `${18 * scale}px ${18 * scale}px ${18 * scale}px ${4 * scale}px`;
    const fontSize = Math.max(8, 10 * scale);

    return css`
      background-color: ${theme.colors.neutral.variant[0]};
      border-radius: ${borderRadius};
      padding: ${padding};
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      word-wrap: break-word;
      white-space: pre-wrap;
      width: ${props.imageWidth * 0.7}px;
      max-width: ${props.imageWidth * 0.7}px;

      color: ${theme.colors.neutral.variant[100]};
      font-size: ${fontSize}px;
      line-height: 1.3;
      margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
    `;
  },
  button: ({ theme, props }) => {
    const baseHeight = 600;
    const scale = props.height / baseHeight;

    const padding = `${8 * scale}px ${12 * scale}px`;
    const borderRadius = `${8 * scale}px`;
    const fontSize = Math.max(8, 10 * scale);
    const minHeight = `${36 * scale}px`;
    const gap = `${8 * scale}px`;

    return css`
      display: flex;
      align-items: center;
      gap: ${gap};
      padding: ${padding};
      background-color: ${theme.colors.neutral.variant[0]};
      border-radius: ${borderRadius};
      font-size: ${fontSize}px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
      color: ${theme.colors.secondary.sky[60]};
      text-decoration: none;
      min-height: ${minHeight};
      pointer-events: none;
      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
      width: ${props.imageWidth * 0.7}px;
      max-width: ${props.imageWidth * 0.7}px;
    `;
  },
  buttonIcon: ({ props }) => {
    const baseHeight = 600;
    const scale = props.height / baseHeight;
    const size = Math.max(8, 16 * scale);

    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      width: ${size}px;
      height: ${size}px;
      flex-shrink: 0;
    `;
  },
  buttonText: () => css`
    flex: 1;
    text-align: left;
  `,
} satisfies Styles<WhatsAppPreviewStyleProps>;

export const useStyles = withStyles(styles);
